<template>
  <div
    class="d-flex w-100 h-max-content"
    :key="$store.state.auth.token + $store.state.auth.user.practice.id"
    :class="containerClass"
  >
    <section class="flex-fill overflow-auto_ left-section d-flex flex-column">
      <top-bar :showUsers="false" :style="[isIntegrationBannerVisible ? { 'margin-bottom': '0 !important' } : {}]" />
      <main class="flex-grow-1 d-flex mt-md-3 overflow-hidden">
        <div class="container-fluid d-flex p-0 px-md-5" v-if="isLoggedIn">
          <div class="d-flex h-100 flex-grow-1">
            <section class="list-pane bg-light">
              <div class="px-3 pt-3 text-center">
                <router-link
                  v-if="!isOrganization"
                  to="/referral/create"
                  tag="button"
                  class="btn btn-lg btn-primary font-weight-bold when-expanded mx-auto pulse"
                  data-v-tour="createReferral"
                  style="padding: 0.85rem 1.75rem"
                  >Create Referral
                </router-link>
              </div>
              <div class="p-3">
                <search-bar :disabled="!isLoaded" class="w-100 search bg-white" />
              </div>
              <div class="pt-2 pt-md-0">
                <filter-bar
                  class="justify-content-start align-self-center"
                  style="margin: 0 auto"
                  @filterChange="onFilterChange"
                />
              </div>
              <div class="referral-list bg-white" :class="{ 'overflow-hidden': !isLoaded }">
                <template v-if="!isLoaded">
                  <placeholders :rounded="false" v-for="i in Array.from({ length: 8 })" :key="i">
                    <placeholders-img class="mt-1" style="height: 100px" :key="i" />
                  </placeholders>
                </template>
                <template v-else-if="all.length > 0">
                  <referral-list-item
                    class="px-3 py-3 referral-item"
                    @click.native="selected(referral)"
                    :item="referral"
                    v-for="referral in all"
                    :key="referral.id"
                    :class="{ selected: referral.id == referralId }"
                  />
                  <div class="mt-3 mb-5 text-muted text-center px-3">
                    <small v-if="all.length > 2" style="border-top: 1px solid var(--border-color)" class="pt-3"
                      >{{ all.length }} referrals since
                      {{ moment(all[all.length - 1].sent_time || all[all.length - 1].created_at).format('ll') }}</small
                    >
                    <div v-if="isLoadingAll" class="mt-3">
                      <font-awesome-icon icon="spinner-third" size="2x" spin />
                    </div>
                    <!-- <img src="../../assets/svg/logo-text.svg" height="30" class="d-block mx-auto mt-3" alt="Refera" /> -->
                  </div>
                  <upgrade-for-all-referrals />
                </template>
                <div v-else class="d-flex flex-grow-1 h-100 align-content-center px-3">
                  <div
                    class="text-hint m-auto d-flex flex-column text-center justify-content-center"
                    style="opacity: 0.62"
                  >
                    <font-awesome-icon
                      :icon="['far', searchTerm ? 'search' : 'inbox']"
                      class="text-hint mx-auto mb-2"
                      size="2x"
                    />
                    <span>{{ searchTerm ? 'No results found' : 'All caught up' }}</span>
                    <a
                      v-if="searchTerm"
                      href="javascript:void(0)"
                      @click="$store.dispatch('referrals/search', null)"
                      class="small"
                      >clear</a
                    >
                    <a v-else-if="referrals.length" href="javascript:void(0)" @click="showAll" class="small"
                      >Show all</a
                    >
                    <upgrade-for-all-referrals />
                  </div>
                  <!-- <empty heading="Nice job" class="my-auto" :cta="false" :image="''"> You're all caught up<br />
                    You dont' have anything in needs action</empty> -->
                </div>
              </div>
            </section>
            <section class="preview-pane flex-grow-1 d-flex flex-column h-100">
              <div
                v-if="isIntegrationBannerVisible"
                class="banner w-100 bg-primary d-flex align-items-center justify-content-center py-3"
              >
                <b class="font-weight-bold text-white" style="font-size: 1.5rem; letter-spacing: -0.3px"
                  >Autofill your referrals with our integration</b
                >
                <calendly><a href="javascript:void(0)" class="btn btn-lg px-5 btn-info ml-3">Upgrade</a></calendly>
              </div>
              <router-view :key="$route.fullPath"></router-view>
            </section>
            <FeedbackModal v-if="isFeedbackModalVisible" @close="isFeedbackModalVisible = false" />
          </div>
        </div>
      </main>
    </section>
    <LoggedInCommon v-if="isLoggedIn && $route.name !== '404'" />
  </div>
</template>

<script>
import TopBar from './TopBar'
import Calendly from '@/components/shared/Calendly'
import { mapState, mapGetters } from 'vuex'
import 'hooper/dist/hooper.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import '@voerro/vue-tagsinput/dist/style.css'
import SearchBar from '@/components/referrals/list/SearchBar'
import FilterBar from '@/components/referrals/list/FilterBar'
import Empty from '@/components/shared/Empty.vue'
import moment from 'moment'

import LoggedInCommon from '@/components/_layout/LoggedInCommon'
import ReferralListItem from '@/components/referrals/inbox/ReferralListItem'

import FeedbackModal from '@/components/referrals/inbox/FeedbackModal.vue'
import UpgradeForAllReferrals from './UpgradeForAllReferrals.vue'
export default {
  components: {
    TopBar,
    LoggedInCommon,
    Calendly,
    SearchBar,
    FilterBar,
    Empty,
    ReferralListItem,
    FeedbackModal,
    UpgradeForAllReferrals,
  },
  data() {
    return {
      isFeedbackModalVisible: true,
    }
  },
  async created() {
    if (!this.$store.state.referrals.isLoaded) {
      await this.$store.dispatch('referrals/load')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isLoggedIn', 'isOrganization']),
    ...mapState('settings', ['isPaymentModalVisible', 'isBannerVisible']),
    ...mapGetters('referrals', ['all', 'get']),
    ...mapState('referrals', [
      'isLoaded',
      'isLoading',
      'searchTerm',
      'error',
      'referrals',
      'contextPracticeId',
      'activeFilter',
      'isLoadingAll',
      'totalCount',
    ]),
    isIntegrationBannerVisible() {
      const practice = this.user?.practice
      return (
        // practice?.specialty == 0 &&
        practice?.is_integration_active === false && this.isBannerVisible && !practice?.has_active_subscription
      )
    },
    containerClass() {
      return this.$route.meta.containerClass
    },
    referralId() {
      return this.$route.params.id
    },
    referral() {
      return this.referralId && this.get(this.referralId)
    },
    isPremium() {
      return this.$store.getters['billing/isPremium']
    },
  },
  methods: {
    selected(referral) {
      const redirect = `/referral/${referral.id}`
      if (this.$route.path == redirect) return
      this.$router.push(redirect)
    },
    showAll() {
      this.$store.dispatch('referrals/filter', 'All')
      this.onFilterChange()
    },
    onFilterChange() {
      if (this.$route.path === '/' && this.all.length && !this.$route.query.to)
        this.$router.push('/referral/' + this.all[0].id)
    },
  },
  mounted() {},
}
</script>
<style scoped lang="scss">
.left-section {
  height: 100vh;
}
.h-max-content {
  height: max-content;
}
.sidebar {
  max-width: 400px;
  width: 25%;
  min-height: 100vh;
}
.banner {
  background-image: url('~@/assets/svg/banner-bg.svg');
  background-position: 50% -16px;
}
.list-pane {
  max-width: 100px;
  min-width: 0;
  width: auto;
  transition: min-width, max-width, width, flex 1s ease-in-out;
  height: 100%;
  display: flex;
  flex-direction: column;
  // max-height: calc(100vh - 60px);
  border-right: 1px solid var(--border-color);

  min-height: min-content;
  background: #f6f6f6;
  overflow-y: hidden;

  .referral-list {
    overflow-y: auto;
    height: 100%;
    .referral-item {
      cursor: pointer;
      border-top: 1px solid var(--border-color);
      &:last-child {
        border-bottom: 1px solid var(--border-color);
      }
      &.selected {
        background-color: var(--light-color);
      }
      &:hover:not(.selected) {
        background-color: var(--border-color);
      }
    }
  }

  &.list-pane-light {
    background: #fff;
    border-right: 1px solid var(--border-color);

    .referral-list {
      .referral-item {
        margin-left: 0.75rem;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        cursor: pointer;
        border-top: none;
        &:last-child {
          border-bottom: none;
        }
        &.selected {
          background-color: var(--light-color);
        }
      }
    }
  }
}

@media (min-width: 576px) {
  .list-pane {
    max-width: 250px;
    min-width: 250px;
  }
}

@media (min-width: 992px) {
  .list-pane {
    max-width: 350px;
    min-width: 320px;
  }
}

@media (min-width: 1200px) {
  .list-pane {
    max-width: 350px;
    min-width: 350px;
  }
}
</style>
